export default function Honeytoken() {
  return (
    <a
      hidden
      aria-hidden="true"
      tabIndex={-1}
      rel="nofollow"
      href="/__forma/honeytoken"
    />
  );
}
